<template>
  <div class="outer-page">
    <x-table
      :no-data-text="CA('nodalPoint_check') ? '暂无数据' : '暂无数据查看权限'"
      :columns="table.columns"
      :data="table.data"
      :loading="table.loading"
      :config="config"
      @search="search"
      @add="add"
      @page-change="pageChange"
      @loadEnter="loadEnter"
      @loadExpend="loadExpend"
      @page-size-change="pageSizeChange"
    ></x-table>
    <Modal
      v-model="modal.show"
      :title="modal.title"
      :width="900"
      @on-visible-change="modalChange"
    >
      <Form :label-width="140" ref="form" :model="form" :rules="rules">
        <Row>
          <Col span="11">
            <FormItem label="集散点名称" prop="serviceName">
              <Input
                v-model="form.serviceName"
                placeholder="请输入集散点名称"
                clearable
              ></Input>
            </FormItem>
          </Col>
          <Col span="11" offset="1">
            <FormItem label="联系人" prop="name">
              <Input
                clearable
                placeholder="请输入联系人"
                v-model="form.name"
              ></Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="11">
            <FormItem label="联系电话" prop="tel">
              <Input
                clearable
                placeholder="请输入联系电话"
                v-model="form.tel"
              ></Input>
            </FormItem>
          </Col>
          <Col span="11" offset="1">
            <FormItem label="企业类型" prop="enterpriseType">
              <Select
                clearable
                placeholder="请输入企业类型"
                v-model="form.enterpriseType"
              >
                <Option
                  v-for="(item, index) in companyData"
                  :key="index"
                  :value="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="11">
            <FormItem label="统一社会信用代码" prop="creditCode">
              <Input
                clearable
                placeholder="请输入统一社会信用代码"
                v-model="form.creditCode"
              ></Input>
            </FormItem>
          </Col>
          <Col span="11" offset="1">
            <FormItem label="省市区编码" prop="region">
              <!-- <Input
            v-model="form.regionCode"
            placeholder="请输入省市区编码"
            clearable
            style="width: 300px"
          ></Input> -->
              <Cascader
                :data="areaList"
                v-model="form.region"
                :load-data="loadData"
                placeholder="请选择区域"
              ></Cascader>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="11">
            <FormItem label="联系地址" prop="serviceAddress">
              <Input
                clearable
                placeholder="请输入联系地址"
                v-model="form.serviceAddress"
              ></Input>
            </FormItem>
          </Col>
          <Col span="11" offset="1">
            <FormItem label="营业期限" prop="businessTerm">
              <Input
                clearable
                placeholder="请输入营业期限"
                v-model="form.businessTerm"
              ></Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="11">
            <FormItem label="业务范围" prop="businessScope">
              <Input
                clearable
                placeholder="请输入业务范围"
                v-model="form.businessScopeName"
                type="textarea"
              ></Input>
            </FormItem>
          </Col>
          <Col span="11" offset="1">
            <FormItem label="位置" prop="thirdLongLat">
              <Input
                v-model="form.thirdLongLat"
                disabled
                placeholder="点击右侧图标选择位置"
              >
                <span
                  slot="append"
                  class="iconfont"
                  @click="mapModalShow"
                  style="cursor: pointer"
                  >&#xe648;</span
                >
              </Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="11">
            <FormItem label="图片上传">
              <upload-image
                :max="1"
                :clear-flag="!modal.show"
                v-model="form.logo"
              ></upload-image>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <p slot="footer" style="text-align: center">
        <Button type="primary" @click="submit">提交</Button>
        <Button @click="() => (this.modal.show = false)">取消</Button>
      </p>
    </Modal>

    <Modal v-model="mapModel" title="选择位置" fullscreen>
      <search-map
        v-if="mapModel"
        :currentData="currentData"
        @back-location="dealMapData"
      ></search-map>
      <p slot="footer" style="text-align: center">
        <Button type="primary" @click="() => (mapModel = false)">提交</Button>
        <Button @click="() => (mapModel = false)">取消</Button>
      </p>
    </Modal>

    <nodal-point-detail
      v-model="nodalPointDetail.show"
      :nodalPointDetailInfo="nodalPointDetail.info"
      :deviceData="deviceData"
      :facilityData="facilityData"
      :imgServicePath="imgServicePath"
    ></nodal-point-detail>

    <picture-view v-model="picture.show" :src="picture.src"></picture-view>
  </div>
</template>

<script>
import { mapState } from "vuex";
import searchMap from "@/components/searchMap";
import pictureView from "@/components/picture_view";
import CU from "@/common/util";
import nodalPointDetail from "./nodalPointDetail.vue";
export default {
  name: "",
  components: { searchMap, pictureView, nodalPointDetail },
  data() {
    return {
      table: {
        columns: [
          {
            title: "LOGO",
            width: 100,
            align: "center",
            render: (h, { row }) => {
              if (!row.logo) return <span>--</span>;
              return (
                <div style="width:60px;height:60px;padding:4px">
                  <img
                    style="width:100%;height:100%;cursor:pointer"
                    src={this.getImgUrl(row.servicePath, row.logo)}
                    onClick={() => this.lookPicture(row.servicePath + row.logo)}
                  />
                </div>
              );
            },
          },
          {
            title: "企业名称",
            minWidth: 100,
            key: "serviceName",
          },
          {
            title: "企业类型",
            key: "enterpriseTypeName",
            minWidth: 60
          },
          {
            title: "统一社会信用代码",
            width: 170,
            align: "center",
            key: "creditCode",
          },
          {
            title: "联系人",
            align: "center",
            key: "name",
          },
          {
            title: "联系电话",
            key: "tel",
            minWidth: 70
          },
          {
            title: "业务范围",
            minWidth: 80,
            tooltip: true,
            key: "businessScopeName",
          },
          {
            title: "区域",
            width: 180,
            tooltip: true,
            key: "regionCodeName",
          },
          {
            title: "服务地址",
            minWidth: 250,
            tooltip: true,
            key: "serviceAddress",
          },
          {
            title: "操作",
            width: 150,
            render: (h, { row }) => {
              return (
                <div>
                  {this.CA("nodalPoint_edit") && (
                    <a
                      style="margin-right:10px"
                      on-click={() => this.edit(row)}
                    >
                      编辑
                    </a>
                  )}
                  {this.CA("nodalPoint_delete") && (
                    <Poptip
                      confirm
                      transfer
                      title="确定删除吗?"
                      on-on-ok={() => this.delete(row.id)}
                    >
                      <a>删除</a>
                    </Poptip>
                  )}
                  {this.CA("nodalPoint_detail") && (
                    <a
                      style="margin-left:10px"
                      on-click={() => this.detail(row)}
                    >
                      详情
                    </a>
                  )}
                </div>
              );
            },
          },
        ],
        data: [],
        loading: false,
      },
      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      search_data: {},
      modal: {
        show: false,
        title: "",
        submitLoading: false,
      },
      form: {
        id: "",
        businessScopeName: "",
        name: "",
        tel: "",
        serviceAddress: "",
        type: 2,
        category: "",
        thirdLongLat: "",
        serviceName: "",
        //社会统一信用代码
        creditCode: "",
        //企业类型
        enterpriseType: "",
        //营业期限
        businessTerm: "",
        //所属行业
        industry: "加工业",
        //省市区编码字符串
        regionCode: "",
        //省市区编码
        region: [],
        logo: "",
      },
      rules: {
        serviceName: [{ required: true, message: "请填写集散点名称" }],
        name: [{ required: true, message: "请填写联系人" }],
        tel: [
          { required: true, message: "请填写联系电话" },
          {
            validator(rule, value, callback) {
              if (!/^1[3|4|5|7|8|9][0-9]{9}$/.test(value)) {
                callback(rule.message);
                return;
              }
              callback();
            },
            message: "手机号格式不正确",
            trigger: "change",
          },
        ],
        serviceAddress: [{ required: true, message: "请输入联系地址" }],
        // creditCode: [{ required: true, message: "请输入社会统一信用代码" }],
        // enterpriseType: [{ required: true, message: "请选择企业类型" }],
        // region: [{ required: true, message: "请输入省市区编码" }],
        // businessScope: [{ required: true, message: "请填写业务范围" }],
        // serviceAddress: [{ required: true, message: "请填写组织地址" }],
        // thirdLongLat: [{ required: true, message: "请选择位置" }],
        // businessTerm: [{ required: true, message: "请输入营业期限" }],
        // industry: [{ required: true, message: "请输入所属行业" }],
        // regionCode: [{ required: true, message: "请输入省市区编码" }],
      },
      mapModel: false,
      currentData: null,
      companyData: [],
      //省市区列表
      areaList: [],

      picture: {
        show: false,
        src: "",
      },
      //详情
      nodalPointDetail: {
        show: false,
        info: {},
      },
      deviceData: [],
      facilityData: [],
      imgServicePath: "",
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
    }),
    config() {
      let config = {
        filter: {
          add: {
            addBtnName: "新增集散点",
            ca: "nodalPoint_add",
          },
          loadModel:{
            url:'https://castoff.hogdata.cn/app/社会化组织和集散点.xlsx'
          },
          loadEnter: {
            loadName: "导入",
            ca: "nodalPoint_import",
          },
          loadExpend: {
            loadExpendName: "导出",
            ca: "",
          },
          width: 200,
          filterBox: [
            // {
            //   conditionName: "业务范围",
            //   component: "input",
            //   field: "businessScope",
            //   defaultValue: "",
            // },
            {
              conditionName: "企业名称",
              component: "input",
              field: "serviceName",
              defaultValue: "",
            },
            {
              conditionName: "企业类型",
              component: "select",
              field: "enterpriseType",
              defaultValue: "",
              data: this.companyData,
              parameterField: "id",
              showField: "name",
            },
            {
              conditionName: "区域",
              component: "cascader",
              field: "regionCode",
              defaultValue: [],
              data: this.areaList,
              isLoadData: true,
              loadData: this.loadData,
            },
            {
              conditionName: "联系人",
              component: "input",
              field: "name",
              defaultValue: "",
            },
            {
              conditionName: "联系电话",
              component: "input",
              field: "tel",
              defaultValue: "",
            },
            {
              conditionName: "服务地址",
              component: "input",
              field: "serviceAddress",
              defaultValue: "",
            },
          ],
        },
        page: { ...this.page },
      };
      return config;
    },
  },
  methods: {
    loadEnter() {
      let input = document.createElement("input");
      input.type = "file";
      input.onchange = (e) => {
        if (!input.files || input.files.length === 0) return;
        let formdata = new FormData();
        formdata.append("file", input.files[0]);
        formdata.append("userId", localStorage.getItem("userId"));
        formdata.append("companyNo", localStorage.getItem("companyNo"));
        formdata.append("category", this.user.category + 1);
        formdata.append("type", 2);
        this.$post(this.$api.SOCIAL_MANAGE.UPLOAD, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }).then(() => {
          this.$Message.success('导入成功')
          this.getList();
        });
      };
      input.click();
    },
    mapModalShow() {
      this.currentData = this.form.thirdLongLat;
      this.mapModel = true;
    },
    dealMapData(positionData) {
      this.form.thirdLongLat = positionData.thirdLongLat;
    },
    getList() {
      if (!this.CA("nodalPoint_check")) return;
      this.table.loading = true;
      this.$post(this.$api.SOCIAL_MANAGE.LIST, {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        type: "2",
        ...this.search_data,
      })
        .then((res) => {
          this.table.data = res.list;
          this.page.total = +res.total;
        })
        .finally(() => {
          this.table.loading = false;
        });
    },
    //省市区列表接口
    getAreaList() {
      this.$post(this.$api.AREA_MANAGE.LIST, {
        parentId: "100000",
      }).then((res) => {
        res.forEach((item) => {
          item.label = item.name;
          item.value = item.id;
          item.loading = false;
          item.children = [];
        });
        this.areaList = res;
      });
    },
    loadData(item, callback) {
      item.loading = true;
      this.$post(this.$api.AREA_MANAGE.LIST, {
        parentId: item.id,
      })
        .then((res) => {
          res.forEach((item) => {
            item.label = item.name;
            item.value = item.id;
            if (item.hasChild == "true") {
              item.loading = false;
              item.children = [];
            }
          });
          item.children = res;
          callback();
        })
        .finally(() => {
          item.loading = false;
        });
    },
    //企业类型
    getCompanyCategory() {
      this.$post(this.$api.SYS_CATEGORY.LIST, {
        pid: "203",
      }).then((res) => {
        this.companyData = res.list;
      });
    },
    search(value) {
      let n;
      for (let i = 0; i < value.regionCode.length; i++) {
        n = value.regionCode[value.regionCode.length - 1];
      }
      let obj = {
        ...value,
        regionCode: n,
      };
      this.search_data = obj;
      this.getList();
    },
    add() {
      this.modal = {
        show: true,
        title: "新增集散点",
        submitLoading: false,
      };
    },
    edit(row) {
      for (let key in this.form) {
        this.form[key] = row[key];
      }
      this.form.region = row.regionCode.split(",");
      this.form.logo = this.getImgUrl(row.servicePath, row.logo);
      this.modal = {
        show: true,
        title: "编辑集散点",
        submitLoading: false,
      };
    },
    delete(id) {
      this.$post(this.$api.SOCIAL_MANAGE.DELETE, {
        id,
      }).then(() => {
        this.$Message.success("删除成功！");
        this.getList();
      });
    },
    submit() {
      this.$refs.form.validate().then((res) => {
        if (!res) return;
        let params = this.form;
        params.category = this.user.category + 1;
        params.regionCode = this.form.region.join(",");
        let index = this.form.logo ? this.form.logo.indexOf("/", 10) : -1;
        if (index !== -1) {
          params.logo = this.form.logo.substring(index + 1);
        }
        let url;
        params.id
          ? (url = this.$api.SOCIAL_MANAGE.UPDATE)
          : (url = this.$api.SOCIAL_MANAGE.ADD);
        this.$post(url, params).then(() => {
          this.$Message.success(params.id ? "修改成功！" : "添加成功！");
          this.getList();
          this.modal.show = false;
          this.modal.submitLoading = false;
        });
      });
    },
    pageChange(pageNo) {
      this.page.pageNo = pageNo;
      this.getList();
    },
    pageSizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.getList();
    },
    modalChange(visible) {
      if (visible) return;
      this.form = {
        id: "",
        businessScope: "",
        businessScopeName: "",
        name: "",
        tel: "",
        serviceAddress: "",
        type: 2,
        category: "",
        serviceName: "",
        thirdLongLat: "",
        //社会统一信用代码
        creditCode: "",
        //企业类型
        enterpriseType: "",
        //营业期限
        businessTerm: "",
        //所属行业
        industry: "加工业",
        //省市区编码字符串
        regionCode: "",
        //省市区编码
        region: [],
        logo: "",
      };
      this.$refs.form.resetFields();
    },

    lookPicture(url) {
      this.picture = {
        show: true,
        src: url,
      };
    },

    loadExpend() {
      let columns = this.table.columns.map((item) => item.title);
      columns.pop();
      let data = this.table.data.map((row) => {
        let rowData = this.table.columns.map((column) => {
          if (column.title == "LOGO") {
            return this.getImgUrl(row.servicePath, row.logo);
          }
          return row[column.key];
        });
        return rowData;
      });
      CU.exportExcel(columns, data, "集散处理点");
    },
    //详情
    detail(row) {
      this.$post(this.$api.SOCIAL_MANAGE.FACILITY, {
        companyNo: row.companyNo,
      }).then((res) => {
        this.deviceData = res.device;
        this.facilityData = res.facility;
        this.imgServicePath = res.servicePath;
        this.nodalPointDetail = {
          show: true,
          info: row,
        };
      });
    },
  },
  mounted() {
    this.getList();
    this.getCompanyCategory();
    this.getAreaList();
  },
};
</script>

<style lang="less" scoped>
.outer-page {
  width: 100%;
  height: 100%;
}
</style>
